/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { LateReplyPrompt } from './LateReplyPrompt';
const meta = {
    title: 'Features/AIChatWidget/LateReplyPrompt',
    component: LateReplyPrompt,
    parameters: { layout: 'padded' },
    args: { onContinue: () => undefined, onDismiss: () => undefined },
    decorators: [
        (Story) => (React.createElement("div", { style: { maxWidth: 500, padding: 16 } },
            React.createElement(Story, null)))
    ]
};
export default meta;
/** The agent replied after the customer ended the chat. */
export const AgentReplied = {};
/** Continue clicked: the call is in flight. */
export const Reconnecting = { args: { isWorking: true } };
/** The support side closed the request: it cannot be continued. */
export const RequestClosed = { args: { closed: true } };
